/** Figma `Checkbox`(Components, 6:182)의 축 */
export type CheckboxSize = 'md' | 'sm';
export type CheckboxStatus = 'default' | 'init';

/** 라벨 글자: md 14(`body`) · sm 12(`caption`). 상자는 두 크기 모두 16 */
export const LABEL_SIZE_CLASS: Record<CheckboxSize, string> = {
  md: 'typo-body',
  sm: 'typo-caption',
};
